import { render, staticRenderFns } from "./GlobalPlanner.vue?vue&type=template&id=51313d47"
import script from "./GlobalPlanner.vue?vue&type=script&lang=js"
export * from "./GlobalPlanner.vue?vue&type=script&lang=js"
import style0 from "./GlobalPlanner.vue?vue&type=style&index=0&id=51313d47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports